import { ArrowForwardIos, CallSplit, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        backgroundColor: "#F0F9FF",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        border: '2px solid rgba(14, 165, 233, 0.3)',
        minWidth: "220px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(45deg, #0ea5e9, #0284c7)",
          width: "20px",
          height: "20px",
          top: "50%",
          left: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(180deg)"
          }}
        />
      </Handle>

      <div
        style={{
          position: "absolute",
          right: "12px",
          top: "12px",
          display: "flex",
          gap: "8px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#0ea5e9"
            }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#ef4444"
            }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px"
        }}
      >
        <CallSplit
          sx={{
            width: "20px",
            height: "20px",
            marginRight: "8px",
            color: "#0ea5e9"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "16px",
          fontWeight: "600",
          letterSpacing: "0.01em"
        }}>
          Randomizador
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px"
        }}
      >
        {data.paths?.map((path, index) => (
            <div
              key={path.path}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#e0f2fe",
                borderRadius: "6px",
                padding: "12px",
                border: "1px solid #bae6fd"
              }}
            >
              <div
                style={{
                  color: "#0369a1",
                  fontSize: "20px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}
              >
                <span style={{
                  backgroundColor: "#0ea5e9",
                  color: "#ffffff",
                  minWidth: "20px",
                  height: "20px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "600"
                }}>
                  {index + 1}
                </span>
                {path.percent}%
              </div>
              <Handle
                type="source"
                position="right"
                id={path.path.toLowerCase()}
                style={{
                  background: "linear-gradient(45deg, #0ea5e9, #0284c7)",
                  width: "20px",
                  height: "20px",
                  position: "relative",
                  right: "-24px",
                  cursor: "pointer",
                  border: "2px solid #ffffff",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}
                isConnectable={isConnectable}
              >
                <ArrowForwardIos
                  sx={{
                    color: "#ffffff",
                    width: "12px",
                    height: "12px",
                    marginLeft: "2px",
                    marginBottom: "1px",
                    pointerEvents: "none"
                  }}
                />
              </Handle>
            </div>
          ))}
      </div>
    </div>
  );
});